import { render, staticRenderFns } from "./ComingSoonScreen.vue?vue&type=template&id=546b8e52&scoped=true"
import script from "./ComingSoonScreen.vue?vue&type=script&lang=js"
export * from "./ComingSoonScreen.vue?vue&type=script&lang=js"
import style0 from "./ComingSoonScreen.vue?vue&type=style&index=0&id=546b8e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546b8e52",
  null
  
)

export default component.exports